<crowdctrl-unauthenticated-page [pageTitle]="pageTitle" [showFooter]="false" defaultHref="/about">
  <div class="about-project">
    <crowdctrl-unauth-page-intro tone="success">
      <h1 crowdctrlUnauthIntroTitle>Thank you</h1>
      <p crowdctrlUnauthIntroLead>
        We have received your details. Someone from the team may follow up by email when
        appropriate.
      </p>
    </crowdctrl-unauth-page-intro>

    <section class="about-project__section" aria-labelledby="ri-thanks-next">
      <h2 id="ri-thanks-next" class="about-project__heading">What you can do next</h2>
      <p class="about-project__text">
        If you already have an account,
        <a
          href="/login"
          class="about-project__inline-link"
          (click)="unauthNav.forward($event, '/login')"
          >sign in here</a
        >, or return to
        <a
          href="/register-interest"
          class="about-project__inline-link"
          (click)="unauthNav.forward($event, '/register-interest')"
          >Register interest</a
        >
        if you need to send another message.
      </p>
    </section>
  </div>
</crowdctrl-unauthenticated-page>
